module.exports = __webpack_public_path__ + "static/media/ils.d7455cf0.mp4";